import DeliveryPlanScreen from './index';
import DetailScreen from './detail';
import CreateScreen from './create';
import UpdateScreen from './update';



const routes = [
  {
    path: '/delivery/plan',
    component: DeliveryPlanScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.fulfillment',
  },
  {
    path: '/delivery/plan/create',
    component: CreateScreen,
    action: ['manage'],
    service: 'nvo.wms.fulfillment',
  },
  {
    path: '/delivery/plan/:id',
    component: DetailScreen,
    action: ['read_only', 'manage'],
    service: 'nvo.wms.fulfillment',
  },
  {
    path: '/delivery/plan/:id/update',
    component: UpdateScreen,
    action: ['manage'],
    service: 'nvo.wms.fulfillment',
  },
];

export default routes;
